// ============================================================
// api.js
// ------------------------------------------------------------
// ตัวยิง API ทั้งระบบ (GET / POST / PUT / DELETE)
//
// เดิม 4 ฟังก์ชันนี้เขียนซ้ำกันเกือบทั้งดุ้น (สร้าง header เอง, ต่อ url เอง,
// จัดการ error เอง) ตอนนี้รวมเหลือ request() ตัวเดียว ส่วน GET/POST/PUT/DELETE
// เป็นแค่ตัวห่อบาง ๆ — พฤติกรรมที่หน้าจอเห็นเหมือนเดิมทุกอย่าง:
//   - สำเร็จ  → return ก้อน result ทั้งก้อน (result.status === true)
//   - ล้มเหลว → เด้ง popup แจ้งเตือน แล้ว return null
// ============================================================

import { alert } from "./alert.js";
import { Logout } from "./storage.js";

// หา base url ของ API
// ถ้าผู้ใช้ตั้ง ip_address ไว้เอง (ปุ่มเฟืองหน้า Login) ให้ยิงไปเครื่องนั้นแทน .env
const getBaseUrl = () => {
  const ip_address = localStorage.getItem("ip_address");
  return ip_address ? `http://${ip_address}:8080/` : process.env.REACT_APP_API_URL;
};

// ต่อ url ให้สมบูรณ์ — ถ้าส่ง url เต็ม (มี "://") มาแล้วใช้ตามนั้นเลย
const toFullUrl = (url) => (url?.includes("://") ? url : getBaseUrl() + url);

// แปลง object เป็น query string เช่น { a: 1, b: 2 } → "?a=1&b=2"
// NOTE เดิมต่อค่าตรง ๆ ไม่ encode — ค่าที่มี & # + % (เช่น ค้นหาชื่อ "A&B", บ้านเลขที่ "12+1")
//      ทำให้ query ขาด/เพี้ยน ตอนนี้ encode เฉพาะ "ค่า" (backend Django decode ให้เองอัตโนมัติ ค่าที่ได้เหมือนเดิม)
const toQueryString = (body) => {
  if (!body) return "";
  return "?" + Object.entries(body).map(([key, value]) => `${key}=${encodeURIComponent(value)}`).join("&");
};

// สร้าง header มาตรฐาน — ใส่ Authorization เฉพาะตอนมี token
export const set_header = async (method_value, token, body) => {
  const headers = { "Content-Type": "application/json", accept: "application/json" };
  if (token) headers.Authorization = token;
  return {
    method: method_value,
    headers,
    cache: "no-cache",
    ...(body ? { body } : {}),
  };
};

// แปลง error ที่ backend ส่งกลับมาเป็นข้อความเดียว แล้วแจ้งผู้ใช้
// ถ้าเป็นเคส token หาย/หมดอายุ ให้เตะออกจากระบบทันที
// NOTE เดิมบรรทัด `else if (result.data.message)` ระเบิดเมื่อ backend ตอบมาโดยไม่มี data
//      (เช่น {status:false, detail:null}) และเพราะฟังก์ชันนี้เป็น async ที่ถูกเรียกแบบไม่ await
//      error จึงกลายเป็น unhandled rejection — ผู้ใช้ไม่เห็น popup อะไรเลย เหมือนกดแล้วเงียบ
//      ตอนนี้ใส่ ?. ให้ครบ และมีข้อความสำรองเสมอ
export async function ERROR(result) {
  const message = result?.detail || (result?.data && !result.data.message ? result.data : result?.data?.message) || result?.message || "เกิดข้อผิดพลาด";

  if (message === "ไม่พบโทเค็น") {
    Logout();
  } else {
    alert("warning", "แจ้งเตือน", message);
  }
}

// แกนกลางของทุก method
// - GET ส่งพารามิเตอร์ทาง query string
// - method อื่นส่งเป็น JSON body
async function request(method, token, url, body) {
  const isGet = method === "GET";
  const fullUrl = toFullUrl(url) + (isGet ? toQueryString(body) : "");
  const header = await set_header(method, token, isGet ? null : body ? JSON.stringify(body) : null);

  try {
    const result = await (await fetch(fullUrl, header)).json();
    if (result.status) return result;
    ERROR(result);
    return null;
  } catch (e) {
    console.error(e);
    alert("warning", "แจ้งเตือน", "เกิดข้อผิดพลาด");
    return null;
  }
}

// อ่านข้อมูล — body จะถูกแปลงเป็น query string
export const GET = (token, url, body) => request("GET", token, url, body);

// สร้างข้อมูลใหม่
export const POST = (token, url, body) => request("POST", token, url, body);

// แก้ไขข้อมูลเดิม
export const PUT = (token, url, body) => request("PUT", token, url, body);

// ลบข้อมูล
export const DELETE = (token, url, body) => request("DELETE", token, url, body);
